import {LoginActionConst, LoginActionByTokenConst,MouseLngLatPositionConst, EditModeConst, AdminDetailObject3DConst, AdminActionPadModeConst, AdminActionCaravanserailStreetLinkingConst} from "../consts"
import {UserActionCaravanserailOpenConst, UserActionOpenCloseChatPrivateConst} from "../consts"


export const onLoginAction = (email, password, navigation) => { 
    return {
    type: LoginActionConst,
    email: email,
    password: password, navigation:  navigation}
};
export const onAuthorizeByTokenAction = (email, password, navigation) => { 
    return {
    type: LoginActionByTokenConst,
    email: email,
    password: password, navigation:  navigation}
};

export const onMouseLngLatPositionAction = (lng, lat, x, y, clicked) => { 
    return {
        type: MouseLngLatPositionConst,
        lng: lng,
        lat: lat,
        x: x,
        y: y,
        clicked: clicked
    }
};

export const onAdminRoadEnableDisbaleAction = (enable) => { 
    return {
        type: MouseLngLatPositionConst,
        enable: enable
    }
};

export const onEditMode = (mode) => { 
    return {
        type: EditModeConst,
        mode: mode
    }
};

export const onDetailObject3D = (element3d, position) => { 
    return {
        type: AdminDetailObject3DConst,
        element3D: element3d,
        position: position,
    }
};

export const onActionPadMode = (mode) => { 
    return {
        type: AdminActionPadModeConst,
        actionPadMode: mode
    }
};

export const onAdminActionCaravanserailStreetLinking = (path) => { 
    return {
        type: AdminActionCaravanserailStreetLinkingConst,
        path: path
    }
};

export const onUserActionCaravanserail = (action) => { 
    return {
        type: UserActionCaravanserailOpenConst,
        action: action
    }
};
export const onUserActionOpenCloseChatPrivate = (action, selection=null) => { 
    return {
        type: UserActionOpenCloseChatPrivateConst,
        action: action,
        selection: selection
    }
};


